import axios from 'axios';
import configs from '../configs';

class ApiService {
  constructor() {
    this.baseURL = configs.api;
  }

  save(data) {
    axios.defaults.withCredentials = true
    return axios.post(this.baseURL, data);
  }

  listMyobFiles(signup) {
    return axios.get(`${configs.myob_api}/files`, { params: { signup } });
  }

  selectMyobFile(signup, fileId, username, password) {
    return axios.post(`${configs.myob_api}/file`, { signup, fileId, username, password });
  }

}

export default new ApiService();
